@if (loader.visible()) {
    <div
        class="dk-global-loader-backdrop"
        role="status"
        [attr.aria-label]="'cropmap.common.loading' | translate"
    >
        <div class="dk-global-loader-container">
            <img
                src="images/logo-login.svg"
                alt=""
                class="dk-global-loader-favicon"
                aria-hidden="true"
            />
        </div>
    </div>
}
